<script>
export default {
    props: {
        
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<template>
  <div class="note">
    <slot />
  </div>
</template>